module.exports = __webpack_public_path__ + "img/Realisme_Fra_romantikk_til_realisme3.a598cffb.jpg";